<template>
  <VDialogV3
    id="characteristic-unit-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localCharacteristicUnit"
    :context-menu="CharacteristicUnitsService.contextMenu"
    :submit-method="submit"
  >
    <section>
      <VInput
        v-model="localCharacteristicUnit.name"
        label="Название"
        layout="vertical"
        required
        :validate-method="validateName"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import CharacteristicUnit         from '@/domains/CharacteristicUnits/CharacteristicUnit';
import CharacteristicUnitsService from '@/domains/CharacteristicUnits/CharacteristicUnitsService';

export default defineComponent({
  name: 'CharacteristicUnitCard',

  props: {
    /** Готовый объект — передаётся из реестра */
    entity: {
      type:    CharacteristicUnit,
      default: null,
    },
    /** ID — карточка сама загружает объект */
    id: {
      type:    Number,
      default: null,
    },
  },

  setup() {
    return {
      CharacteristicUnitsService,
    };
  },

  data() {
    return {
      localCharacteristicUnit: null as CharacteristicUnit | null,
    };
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localCharacteristicUnit = await CharacteristicUnitsService.get(this.id);
      }
      else if (this.entity instanceof CharacteristicUnit) {
        this.localCharacteristicUnit = this.$core.utils.cloneDeep(this.entity);
      }
      else {
        this.localCharacteristicUnit = new CharacteristicUnit();
      }
    },

    async submit(): Promise<boolean> {
      if (this.localCharacteristicUnit.isExisting === true) {
        return await CharacteristicUnitsService.update(this.localCharacteristicUnit);
      }
      else {
        return await CharacteristicUnitsService.add(this.localCharacteristicUnit);
      }
    },

    async validateName(value: string): Promise<string | null> {
      if (typeof value !== 'string' || value.length === 0) return null;
      if (value.trim().length === 0) return 'Поле обязательно для заполнения и не может быть пустым';
      if (value.length > 50) return 'Максимальная длина поля 50 символов';
      return null;
    },
  },
});
</script>